'use strict';

(function ($) {
  /*
  function initWidgetData($widget) {
    $widget.find('.status-row').draggable({
      helper: 'clone',
      containment: $widget,
      appendTo: $widget,
      zIndex: 100,
      cursorAt: { left: 25, top: 10 },
      classes: { 'ui-draggable-dragging': 'status-row-dragged' }
    });
    $widget.find('.status-data').droppable({
      accept: '.status-row',
      tolerance: 'pointer',
      drop: function (event, ui) {
        var $source = ui.draggable;
        var $target = $(this);

        if (!$source.closest('.status-data').is($target)) {
          $target.append($source);
        }
      }
    });
  }
  */

  var methods = {
    init: function (/*options*/) {
      /*var opts = $.extend({}, $.fn.widget_jobQueue.defaults, options);*/

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('widget-job-queue-status-chart-init')) {
          return;
        }

        $this.addClass('widget-job-queue-status-chart-init');

        /*
        $this.on('loadWidgetContent', function () {
          initWidgetData($this);
        });

        initWidgetData($this);
        */

      });
    },
  };

  $.fn.widget_jobQueueStatusChart = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.widget_jobQueueStatusChart');
    }

  };

  $.fn.widget_jobQueueStatusChart.defaults = {};

})(jQuery);
